import { ISearchUnderlying } from "src/api/client/search-autocomplete.api.types";
import { IAvatarSize } from "src/components-mui/base/avatar/avatar.constants";
import { UnderlyingLogo } from "src/components-mui/common/underlying-logo/underlying-logo";

interface ISearchItemLogoProps extends Pick<ISearchUnderlying, "logoUrl" | "shortDescription"> {
    size?: IAvatarSize;
}

export const SearchItemLogo = ({ logoUrl, shortDescription, size = "xs" }: ISearchItemLogoProps) => (
    <UnderlyingLogo logoUrl={logoUrl} alt={shortDescription} size={size} sx={{ flexShrink: 0, mr: 1 }} />
);
